export default {"src":"/_next/static/media/0x375abb85c329753b1ba849a601438ae77eec9893.82af9db9.svg","height":29,"width":31,"blurWidth":0,"blurHeight":0};